export default "__VITE_ASSET__CPhVYRvO__"